<div class="enhanced-call-modal" 
     [class.call-answered]="isCallAnswered()" 
     [class.call-ended]="showCallEnded()" 
     [class.processing]="isProcessing()">
  
  <!-- Modal Header -->
  <div class="call-header">
    <div class="call-status">
      <mat-icon 
        class="status-icon" 
        [class.ringing]="isRinging()"
        [class.answered]="isCallAnswered()"
        [class.ended]="showCallEnded()">
        {{ callStateIcon() }}
      </mat-icon>
      <span class="status-text">{{ callStateMessage() }}</span>
    </div>

    <!-- Ring Duration -->
    <div class="duration-display" *ngIf="isRinging() && ringDuration() > 0">
      <mat-icon class="timer-icon">timer</mat-icon>
      <span class="duration-text">{{ formattedRingDuration() }}</span>
    </div>
  </div>

  <!-- Caller Information Section -->
  <div class="caller-section">
    <!-- Caller Avatar -->
    <div class="caller-avatar">
      <div class="avatar-circle" [class.known-caller]="isKnownCaller()" [class.loading]="isLoadingLeadInfo()">
        <mat-spinner
          *ngIf="isLoadingLeadInfo()"
          diameter="40"
          strokeWidth="3">
        </mat-spinner>
        <span class="avatar-initials" *ngIf="!isLoadingLeadInfo()">{{ getLeadInitials() }}</span>
      </div>
      <div class="caller-status" *ngIf="isKnownCaller() && !isLoadingLeadInfo()">
        <mat-icon class="status-badge">verified_user</mat-icon>
      </div>
    </div>

    <!-- Caller Details -->
    <div class="caller-details">
      <h2 class="caller-name">
        {{ callerDisplayName() }}
        <mat-spinner
          *ngIf="isLoadingLeadInfo()"
          diameter="20"
          strokeWidth="2"
          class="inline-loading-spinner">
        </mat-spinner>
      </h2>
      <p class="caller-phone">{{ callerPhoneNumber() }}</p>

      <!-- Lead Information (if available) -->
      <div class="lead-info" *ngIf="isKnownCaller() && leadInfo() && !isLoadingLeadInfo()">
        <div class="info-row">
          <mat-icon class="info-icon">business</mat-icon>
          <span class="info-text">{{ getCampusInfo() }}</span>
        </div>
        
        <div class="info-row">
          <mat-icon class="info-icon">school</mat-icon>
          <span class="info-text">{{ getProgramInfo() }}</span>
        </div>
        
        <div class="info-row">
          <mat-icon class="info-icon">person</mat-icon>
          <span class="info-text">{{ getOwnerInfo() }}</span>
        </div>
        
        <div class="info-row">
          <mat-icon class="info-icon">label</mat-icon>
          <span class="info-text status-badge" [class]="getLeadStatus().toLowerCase()">
            {{ getLeadStatus() }}
          </span>
        </div>
      </div>

      <!-- Loading Information -->
      <div class="loading-caller-info" *ngIf="isLoadingLeadInfo()">
        <div class="info-row">
          <mat-icon class="info-icon loading">search</mat-icon>
          <span class="info-text">Searching for caller information...</span>
        </div>
      </div>

      <!-- Unknown Caller Information -->
      <div class="unknown-caller-info" *ngIf="!isKnownCaller() && !isLoadingLeadInfo()">
        <div class="info-row">
          <mat-icon class="info-icon warning">contact_phone</mat-icon>
          <span class="info-text">Unknown caller - not in system</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Call History & Context -->
  <div class="call-context" *ngIf="callContext() && !isLoadingLeadInfo()">
    <div class="context-item">
      <mat-icon class="context-icon">history</mat-icon>
      <span class="context-text">{{ getCallHistoryInfo() }}</span>
    </div>
  </div>

  <!-- Suggested Actions -->
  <div class="suggested-actions" *ngIf="getSuggestedActions().length > 0 && !isLoadingLeadInfo()">
    <h4 class="actions-title">
      <mat-icon>lightbulb</mat-icon>
      Suggested Actions
    </h4>
    <div class="actions-list">
      <div class="action-item" *ngFor="let action of getSuggestedActions()">
        <mat-icon class="action-icon">check_circle_outline</mat-icon>
        <span class="action-text">{{ action }}</span>
      </div>
    </div>
  </div>

  <!-- Call Action Buttons (Incoming Call) -->
  <div class="call-actions incoming-actions" *ngIf="!showCallEnded() && !isCallAnswered()">
    <button 
      mat-fab
      color="warn"
      [disabled]="!canDeclineCall()"
      (click)="declineCall()"
      class="action-button decline-button"
      matTooltip="Decline call"
      aria-label="Decline call">
      <mat-icon>call_end</mat-icon>
    </button>

    <button 
      mat-fab
      color="primary"
      [disabled]="!canAnswerCall()"
      (click)="answerCall()"
      class="action-button answer-button"
      [matTooltip]="isProcessing() ? 'Connecting...' : 'Answer call'"
      aria-label="Answer call">
      
      <mat-spinner 
        *ngIf="isProcessing()" 
        diameter="28" 
        strokeWidth="3"
        class="processing-spinner">
      </mat-spinner>
      
      <mat-icon *ngIf="!isProcessing()">call</mat-icon>
    </button>
  </div>

  <!-- Call Ended Message -->
  <div class="call-ended-section" *ngIf="showCallEnded()">
    <div class="ended-icon-container">
      <mat-icon class="ended-icon">call_end</mat-icon>
    </div>
    <h3 class="ended-title">Call Ended</h3>
    <p class="ended-description">This window will close automatically</p>
  </div>

  <!-- Processing Overlay -->
  <div class="processing-overlay" *ngIf="isProcessing() && !showCallEnded()">
    <mat-spinner diameter="48" strokeWidth="4"></mat-spinner>
    <span class="processing-text">{{ callStateMessage() }}</span>
    <div class="processing-details" *ngIf="calls.currentState() === 'connecting'">
      <small>Bridging call with backend...</small>
    </div>
  </div>

  <!-- Pulsing Animation for Incoming Call -->
  <div class="pulse-animation" *ngIf="isRinging() && !isProcessing()"></div>

  <!-- Close Button (Emergency Exit) -->
  <button 
    mat-icon-button
    class="close-button"
    [disabled]="isProcessing()"
    (click)="dismiss('manual')"
    matTooltip="Close (Emergency)"
    aria-label="Close call modal"
    *ngIf="!isCallAnswered()">
    <mat-icon>close</mat-icon>
  </button>
</div>